export const DEVICE_LOCALES=["en-US", "en-CA", "fr-CA", "en-IN", "en-GB", "de-DE", "hi-IN",
 "es-ES", "es-US", "es-PE", "ja-JP", "fr-FR", "it-IT", "en-IE", "en-AU", "pt-BR", "es-MX",
  "en-CO", "en-NZ", "de-NL", "nl-NL", "pl-PL", "sv-SE"]
